import { createMemroyTokenService } from '../memory-token.service'

export const memroyTokenService = createMemroyTokenService()
